/** Verdetto per opzione al reveal.
 *
 * Sugli "ordina-3" la risposta giusta contiene tutte e tre le opzioni: non basta
 * chiedersi se l'opzione e' nella risposta, va confrontata la posizione.
 */

import type { Risposta, Tipo } from "../../worker/src/protocol";

export type Verdetto = "giusta" | "sbagliata" | "";

export function verdetto(
  tipo: Tipo,
  opzione: string,
  risposta: Risposta,
  mia: Risposta | null,
): Verdetto {
  const scelte = Array.isArray(mia) ? mia : mia ? [mia] : [];
  if (tipo === "ordina-3") {
    const giuste = Array.isArray(risposta) ? risposta : [];
    if (scelte.length === 0) return ""; // non ha risposto: niente verde, niente rosso
    return scelte.indexOf(opzione) === giuste.indexOf(opzione) ? "giusta" : "sbagliata";
  }
  if (opzione === risposta) return "giusta";
  return scelte.includes(opzione) ? "sbagliata" : "";
}

/** Posizione giusta (1-3) e quella data dal giocatore, per il pallino. */
export function posizioni(opzione: string, risposta: Risposta, mia: Risposta | null) {
  const giuste = Array.isArray(risposta) ? risposta : [];
  const scelte = Array.isArray(mia) ? mia : [];
  const g = giuste.indexOf(opzione);
  const t = scelte.indexOf(opzione);
  return { giusta: g >= 0 ? g + 1 : null, tua: t >= 0 ? t + 1 : null };
}
